<!-- 添加就诊人 -->
<template>
  <div class="addClient">
    <div class="card" v-for="(item, index) in cardList" :key="'card' + index" :style="item.cardSytle" @click="routerPush(item)">
      <div class="cardDescription">
        <div class="title">{{ item.title }}</div>
        <div class="description">{{ item.description }}</div>
      </div>
      <div class="cardImage">
        <img :src="item.image" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddClient',
  data() {
    return {
      cardList: [
        // {
        //   title: '申领电子健康卡',
        //   description: '通过有效证件申领电子健康卡，用于预约挂号、报告查询等',
        //   image: require('@/assets/icons/electronicHealthCard.png'),
        //   cardSytle: { border: '1px solid #18CC93', background: '#DCFFEE' },
        //   route: 'applyHealthCard'
        // },
        {
          title: '申领已有就诊卡',
          description: '已有窗口办理的就诊卡在此绑定',
          image: require('@/assets/icons/medicalCard.png'),
          cardSytle: { border: '1px solid #4492FE', background: '#DAEBFF' },
          route: 'applyMedicalCard'
        },
        {
          title: '小儿卡注册',
          description: '仅限未上户口(无身份证号)的新生儿，已上户口请注册电子健康卡',
          image: require('@/assets/icons/childCard.png'),
          cardSytle: { border: '1px solid #AAA3F8', background: '#F1E3FF' },
          route: 'childCardRegistration'
        }
      ]
    };
  },
  methods: {
    routerPush(val) {
      if (!val.route) {
        return;
      }
      this.$router.push({ path: val.route });
    }
  }
};
</script>

<style lang="scss" scoped>
.addClient {
  width: 100vw;
  height: 100vh;
  background: #f9f9f9;
  overflow: hidden;
  overflow-y: auto;
  .card {
    margin: 0 auto;
    margin-top: 1.2vh;
    width: 94.7vw;
    height: 17.2vh;
    border-radius: 2.1vw;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .cardDescription {
      width: 45vw;
    }
    .title {
      font-size: 5.3vw;
      font-weight: 500;
      margin-bottom: 1.8vh;
    }
    .description {
      font-size: 3.7vw;
      color: #3a3a3a;
    }
    .cardImage {
      img {
        width: 33.6vw;
        height: 9.9vh;
      }
    }
  }
}
</style>
